<script lang="ts">
import { defineComponent } from 'vue';
import { AisRefinementList } from 'vue-instantsearch/vue3/es';

export default defineComponent({
  components: {
    AisRefinementList,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    attribute: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
});
</script>
<template>
  <div class="pt-6 first:pt-0">
    <h4 class="pt-6 mb-4 text-xl font-bold leading-normal">{{ label }}</h4>
    <ais-refinement-list
      :attribute="attribute"
      :limit="100"
      :sort-by="['name:asc']"
      :class-names="{
        'ais-RefinementList-item': 'mb-2',
        'ais-RefinementList-count': 'hidden',
        'ais-RefinementList-label': 'flex items-center gap-5',
        'ais-RefinementList-labelText': 'text-xl leading-9',
        'ais-RefinementList-checkbox':
          'form-checkbox focus:ring-offset-gtg-pink-700 checked:text-white checked:hover:text-white checked:focus:text-white checked:border-gtg-teal-300 checked:focus:border-gtg-teal-300 checked:hover:border-gtg-teal-300 checked:bg-checkbox-on-purple shrink-0 size-5 border-transparent rounded focus:ring-gtg-teal-300 text-teal-300',
      }"
    />
  </div>
</template>
